import React, { KeyboardEventHandler, KeyboardEvent, useRef, useState } from 'react';
import s from './input.module.scss';
import InputWraper from '../InputWraper/InputWraper';
import { onEnter } from '../../utils/onEnter';

interface InputProps {
    className?: string;
    small?: boolean;
    onChange: (value: string) => void;
    onSubmit?: () => void;
    onKeyDown?: (arg?: KeyboardEvent) => void;
    value: number | string;
    type?: 'text' | 'number' | 'password' | 'date' | 'time';
    label: string;
    error: boolean;
    errorMessage?: string;
    disabled?: boolean;
    placeholder?: string;
    dateMin?: string;
    dateMax?: string;
}

const Input = ({
    small,
    onChange,
    onSubmit,
    onKeyDown,
    value,
    type = 'text',
    label,
    error = false,
    errorMessage,
    disabled = false,
    placeholder,
    className,
    dateMin,
    dateMax,
}: InputProps) => {
    const [isActive, setActive] = useState(false);
    const ref = useRef<HTMLInputElement | null>(null);

    const setInputFocus = () => {
        ref.current?.focus();
        setActive(true);
    };

    const onKeyPress: KeyboardEventHandler<HTMLInputElement> = (e) => {
        if (typeof onSubmit === 'function') {
            onEnter(e, onSubmit);
        } else if (typeof onKeyDown === 'function') {
            onKeyDown(e);
        }
    };

    return (
        <InputWraper
            label={label}
            error={error}
            errorMessage={errorMessage}
            onClick={setInputFocus}
            className={className}
            isActive={isActive || value}
            isFocused={isActive}
            small={small}
        >
            <input
                onChange={(e) => onChange(e.target.value)}
                className={s.input}
                value={value}
                type={type}
                disabled={disabled}
                placeholder={placeholder}
                ref={ref}
                onBlur={() => setActive(false)}
                onFocus={setInputFocus}
                onKeyDown={onKeyPress}
                min={dateMin}
                max={dateMax}
            />
        </InputWraper>
    );
};

export default Input;
